// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: var(--ids-swappable-item-font-family);
  border: var(--ids-swappable-item-border-default);
  cursor: var(--ids-swappable-item-cursor-default);
  padding-inline: var(--ids-swappable-item-padding-inline);
  padding-block: var(--ids-swappable-item-padding-block);
  height: var(--ids-swappable-item-height);
  display: flex;
  flex-direction: row;
  transition: height 0.4s ease, padding 0.4s ease;
  overflow: hidden;
}

:host([hidden]) {
  display: none;
}

::slotted(.sortable) {
  width: 100%;
}

ids-icon {
  margin-inline: var(--ids-swappable-item-icon-margin-inline);
  visibility: hidden;
}

:host(:hover) ids-icon {
  visibility: visible;
}

:host([dir=rtl]:hover)::before {
  left: unset;
  right: 5px;
  transform: translate(-1px, -47%);
}

:host(:focus:not(.hide-focus)) {
  border: var(--ids-swappable-item-border-focus);
  box-shadow: var(--ids-swappable-item-shadow-focus);
  outline: var(--ids-swappable-item-outline-focus);
}

:host([selected]) {
  cursor: var(--ids-swappable-item-cursor-selected);
}

:host([dragging]) {
  opacity: var(--ids-swappable-item-opacity-dragging);
}

:host([dragging]:not(.slotted-ids-tab)),
:host([selected]:not(.slotted-ids-tab)) {
  background-color: var(--ids-swappable-item-color-background-selected);
  border: 1px solid var(--ids-swappable-item-color-border-selected);
  color: var(--ids-swappable-item-color-text-selected);
}

:host([over]) {
  border: var(--ids-swappable-item-over-border);
}

:host(.is-hidden) {
  height: var(--ids-space-none);
  padding: var(--ids-space-none);
  border: none;
  overflow: hidden;
}

::slotted(ids-tab) {
  position: relative;
  margin: -1px;
}

:host(.slotted-ids-tab:not(.orientation-vertical)) {
  margin-inline-start: var(--ids-space-2xs);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-swappable/ids-swappable-item.scss"],"names":[],"mappings":"AAAA;EACE,kDAAA;EACA,gDAAA;EACA,gDAAA;EACA,wDAAA;EACA,sDAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,2DAAA;EACA,kBAAA;AACF;;AAGE;EACE,mBAAA;AAAJ;;AAKE;EACE,WAAA;EACA,UAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,8CAAA;EACA,kDAAA;EACA,gDAAA;AAHF;;AAMA;EACE,iDAAA;AAHF;;AAMA;EACE,mDAAA;AAHF;;AAMA;;EAEE,qEAAA;EACA,iEAAA;EACA,oDAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAMA;EACE,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AAHF;;AASA;EACE,kBAAA;EACA,YAAA;AANF;;AASA;EACE,yCAAA;AANF","sourcesContent":[":host {\n  font-family: var(--ids-swappable-item-font-family);\n  border: var(--ids-swappable-item-border-default);\n  cursor: var(--ids-swappable-item-cursor-default);\n  padding-inline: var(--ids-swappable-item-padding-inline);\n  padding-block: var(--ids-swappable-item-padding-block);\n  height: var(--ids-swappable-item-height);\n  display: flex;\n  flex-direction: row;\n  transition: height 0.4s ease, padding 0.4s ease;\n  overflow: hidden;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n::slotted(.sortable) {\n  width: 100%;\n}\n\nids-icon {\n  margin-inline: var(--ids-swappable-item-icon-margin-inline);\n  visibility: hidden;\n}\n\n:host(:hover) {\n  ids-icon {\n    visibility: visible;\n  }\n}\n\n:host([dir='rtl']:hover) {\n  &::before {\n    left: unset;\n    right: 5px;\n    transform: translate(-1px, -47%);\n  }\n}\n\n:host(:focus:not(.hide-focus)) {\n  border: var(--ids-swappable-item-border-focus);\n  box-shadow: var(--ids-swappable-item-shadow-focus);\n  outline: var(--ids-swappable-item-outline-focus);\n}\n\n:host([selected]) {\n  cursor: var(--ids-swappable-item-cursor-selected);\n}\n\n:host([dragging]) {\n  opacity: var(--ids-swappable-item-opacity-dragging);\n}\n\n:host([dragging]:not(.slotted-ids-tab)),\n:host([selected]:not(.slotted-ids-tab)) {\n  background-color: var(--ids-swappable-item-color-background-selected);\n  border: 1px solid var(--ids-swappable-item-color-border-selected);\n  color: var(--ids-swappable-item-color-text-selected);\n}\n\n:host([over]) {\n  border: var(--ids-swappable-item-over-border);\n}\n\n:host(.is-hidden) {\n  height: var(--ids-space-none);\n  padding: var(--ids-space-none);\n  border: none;\n  overflow: hidden;\n}\n\n// Fixes slotted IdsTabs to appear flush with their containers\n// (IdsSwappableItem causes a 1px boundary as a result of its required transparent border)\n// @TODO: Relocate this to another component / review wrapping, separation of concerns\n::slotted(ids-tab) {\n  position: relative;\n  margin: -1px;\n}\n\n:host(.slotted-ids-tab:not(.orientation-vertical)) {\n  margin-inline-start: var(--ids-space-2xs);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
